/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An expressions for filtering screening alerts
 * @export
 * @interface ApiScreeningAlertFilterExpression
 */
export interface ApiScreeningAlertFilterExpression {
    /**
     * 
     * @type {ApiScreeningAlertFilterExpressionTargetEnum}
     * @memberof ApiScreeningAlertFilterExpression
     */
    target: ApiScreeningAlertFilterExpressionTargetEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningAlertFilterExpression
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningAlertFilterExpression
     */
    value: string;
    /**
     * 
     * @type {ApiScreeningAlertFilterExpressionFieldTypeEnum}
     * @memberof ApiScreeningAlertFilterExpression
     */
    fieldType: ApiScreeningAlertFilterExpressionFieldTypeEnum;
    /**
     * 
     * @type {ApiScreeningAlertFilterExpressionOperationEnum}
     * @memberof ApiScreeningAlertFilterExpression
     */
    operation: ApiScreeningAlertFilterExpressionOperationEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiScreeningAlertFilterExpressionTargetEnum {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    ALERT = 'ALERT',
    HIT = 'HIT',
    CLEARANCE = 'CLEARANCE',
    ALERT_NOTE = 'ALERT_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum ApiScreeningAlertFilterExpressionFieldTypeEnum {
    STRING = 'STRING',
    STRING_LIST = 'STRING_LIST',
    NUMBER = 'NUMBER',
    TIMESTAMP = 'TIMESTAMP'
}
/**
* @export
* @enum {string}
*/
export enum ApiScreeningAlertFilterExpressionOperationEnum {
    EQUALS = 'EQUALS',
    EQUALS_ONE_OF = 'EQUALS_ONE_OF',
    GREATER_THAN = 'GREATER_THAN',
    LESS_THAN = 'LESS_THAN',
    PARTLY_MATCHES = 'PARTLY_MATCHES',
    NOT_EQUALS = 'NOT_EQUALS',
    NOT_EQUALS_ONE_OF = 'NOT_EQUALS_ONE_OF',
    NO_PARTIAL_MATCH = 'NO_PARTIAL_MATCH'
}


/**
 * Check if a given object implements the ApiScreeningAlertFilterExpression interface.
 */
export function instanceOfApiScreeningAlertFilterExpression(value: object): value is ApiScreeningAlertFilterExpression {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('fieldType' in value) || value['fieldType'] === undefined) return false;
    if (!('operation' in value) || value['operation'] === undefined) return false;
    return true;
}

export function ApiScreeningAlertFilterExpressionFromJSON(json: any): ApiScreeningAlertFilterExpression {
    return ApiScreeningAlertFilterExpressionFromJSONTyped(json, false);
}

export function ApiScreeningAlertFilterExpressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningAlertFilterExpression {
    if (json == null) {
        return json;
    }
    return {
        
        'target': json['target'],
        'field': json['field'],
        'value': json['value'],
        'fieldType': json['fieldType'],
        'operation': json['operation'],
    };
}

export function ApiScreeningAlertFilterExpressionToJSON(json: any): ApiScreeningAlertFilterExpression {
    return ApiScreeningAlertFilterExpressionToJSONTyped(json, false);
}

export function ApiScreeningAlertFilterExpressionToJSONTyped(value?: ApiScreeningAlertFilterExpression | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': value['target'],
        'field': value['field'],
        'value': value['value'],
        'fieldType': value['fieldType'],
        'operation': value['operation'],
    };
}

